import { render, staticRenderFns } from "./GouPickFile.vue?vue&type=template&id=649b113d&scoped=true"
import script from "./GouPickFile.vue?vue&type=script&lang=js"
export * from "./GouPickFile.vue?vue&type=script&lang=js"
import style0 from "./GouPickFile.vue?vue&type=style&index=0&id=649b113d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649b113d",
  null
  
)

export default component.exports